<template>
  <v-row>
    <v-dialog
      v-model="dialogInput"
      persistent
      width="600px"
      v-for="(item, index) in dialogItem"
      :key="index"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="grey lighten-3" icon text v-bind="attrs" v-on="on" class="grey lighten-3">
          <v-icon class="primary--text ml-16 mr-1" size="30">{{ item.icon }}</v-icon>
          <span class="primary--text text-body-2 text-capitalize mr-12">{{ item.name }}</span>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="d-flex text-body-1 justify-center">
          <span class="mt-8">Llave de Correctores</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <p class="text-body-2">
              Es necesario adjuntar un Excel de “Llave de Correctores” con la información que <br />
              usted considere conveniente para la corrección de pruebas.
            </p>
            <v-row class="mx-auto mt-6 mb-3 justify-center" v-if="nameLLaveCo === undefined">
              <v-col col="7" sm="7">
                <input type="file" label="LLave Excel" ref="file" @change="uploadFileLLaveCo" />
              </v-col>
              <v-col col="3" sm="3" class="d-flex justify-center align-center">
                <v-btn
                  small
                  color="primary"
                  @click.prevent="confirmUploadFileLLaveCo"
                  @input="handleEvents"
                >
                  Adjuntar
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="justify-center" v-else>
              <span class="my-5">Se encuentra adjuntado el archivo: {{ nameLLaveCo }}</span>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="blue darken-1" @click="deleteLlaveCo"> Desadjuntar </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-1" @click="closeDialog()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'VDialogCoKey',
  props: [
    'dialogItem',
    'uploadFileLLaveCo',
    'confirmUploadFileLLaveCo',
    'nameLLaveCo',
    'deleteLlaveCo',
    'dialog',
    'handleEvents',
  ],
  data() {
    return {
      switch1: false,
      dialogInput: null,
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
    closeDialog() {
      this.dialogInput = false;
    },
  },
};
</script>
